"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = void 0;
exports.path = '/has-agreed-to-current-acceptance-package';
//# sourceMappingURL=index.js.map